import React from "react";
import CopyResultButton from "../../../components/CopyResultButton";
import AdaObserved from "../../../components/AdaObserved";
import { factText, factParts, soFar } from "../../../../../core/data/marketOverviewText";

// "AdA observed" facts, plus a localhost-only button to copy the exact result.
export function FactRow({ result }) {
  const facts = result.facts.map((f, i) => ({ id: `${i}-${f.claim}`, ...factParts(f), title: factText(f) }));
  return <AdaObserved facts={facts} suffix={soFar(result)} right={<CopyResultButton result={result} />} />;
}
